module.exports = __webpack_public_path__ + "img/hdc_06.62d2021a.png";